import { InputMode } from '../types/mode';
import { defaultInputType, InputType } from '../types/type';
export const getInputType = (type) => {
    if (!type) {
        return defaultInputType;
    }
    switch (type) {
        case InputType.Decimal:
            return InputType.Number;
        default:
            return type;
    }
};
export const getInputMode = (type) => {
    if (!type) {
        return undefined;
    }
    switch (type) {
        case InputType.Decimal:
            return InputMode.Decimal;
        case InputType.Text:
        case InputType.Password:
            return InputMode.Text;
        case InputType.Email:
            return InputMode.Email;
        case InputType.Phone:
            return InputMode.Phone;
        case InputType.Number:
            return InputMode.Numeric;
        default:
            return undefined;
    }
};
//# sourceMappingURL=utils.js.map